module.exports = __webpack_public_path__ + "img/B.b88a44ad.webp";